import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntYearSelectorComponent} from "./int-year-selector.component";
import {CellPositionModule} from "../../directives/cell-position/cell-position.module";
import {IntScrollingLayerModule} from "../../../features/components/scrolling-layer/int-scrolling-layer.module";
import {IntCalendarActionCellModule} from "../action";

@NgModule({
  imports: [
    CommonModule,
    CellPositionModule,
    IntScrollingLayerModule,
    IntCalendarActionCellModule
  ],
  declarations: [
    IntYearSelectorComponent
  ],
  exports: [
    IntYearSelectorComponent

  ]
})
export class IntYearSelectorModule {}
